import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import moment from 'moment-timezone';
import './SaveStatus.scss';
import { Button } from 'v5/design-system/Button';
import { AlertTriangle } from 'lucide-react';
import { SimpleTooltip } from 'v5/design-system/Tooltip';
import { ensureError } from '@passionware/platform-js';

class SaveStatus extends Component {
  render() {
    const { loading, updated, errors } = this.props;

    // Check if loading is a number (pending operations count) or boolean
    const hasPendingOperations = typeof loading === 'number' && loading > 0;
    const isRegularLoading = typeof loading === 'boolean' && loading;

    return (
      <div
        className={classnames(
          { loading: isRegularLoading || hasPendingOperations },
          ['SaveStatus']
        )}
      >
        {isRegularLoading || hasPendingOperations ? (
          <span className="SaveStatus-saving">
            {hasPendingOperations ? (
              <div className="tailwind-root">
                <div className="flex items-center gap-2 text-brand-600">
                  <div className="ml-0.5 w-2 h-2 bg-brand-500 rounded-full animate-pulse"></div>
                  <span>
                    {loading} pending update{loading !== 1 ? 's' : ''}
                  </span>
                </div>
              </div>
            ) : (
              'Saving...'
            )}
          </span>
        ) : (
          <div
            data-tip={`Saved ${moment(updated).fromNow()}`}
            className="SaveStatus-saved"
          >
            Saved{' '}
            <img
              className="inline-block"
              src="/images/icon_tick_green.svg"
              alt=""
              width="11px"
            />
          </div>
        )}
        {errors?.length > 0 && (
          <div className="tailwind-root contents">
            <SimpleTooltip
              align="start"
              side="bottom"
              title={errors.map((e, i) => (
                <div key={i}>{ensureError(e).message}</div>
              ))}
            >
              <Button variant="ghost" size="xs" layout="icon">
                <AlertTriangle className="text-fg-danger" />
              </Button>
            </SimpleTooltip>
          </div>
        )}
      </div>
    );
  }
}

SaveStatus.propTypes = {
  loading: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.string,
    PropTypes.number
  ]),
  updated: PropTypes.any // TODO: type - date?
};

export default SaveStatus;
